import { observer } from 'mobx-react-lite';
import styles from '@features/cart/components/CartProductPrices/CartProductPrices.styles';
import CartPriceSkeleton from '@features/cart/components/CartPriceSkeleton/CartPriceSkeleton';
import { CartProductPricesType } from '@features/cart/typescript';
import { formatPrice } from '@utils/formatPrice';

type PropsType = {
  prices: CartProductPricesType;
  isProductLoading: boolean;
  classNames?: Record<string, unknown>;
  /** @deprecated Prefer per-position `prices.taxRate`; kept as fallback when taxRate is absent (e.g. legacy orders). */
  isStorAssemblyAvailable?: boolean;
};

const shouldUseAssemblyPrice = (prices: CartProductPricesType, isStorAssemblyAvailable: boolean): boolean => {
  if (prices.taxRate != null && prices.taxRate !== '') {
    return prices.taxRate.toString() === '8';
  }

  return isStorAssemblyAvailable;
};

const CartProductPrices = ({
  prices,
  isProductLoading,
  classNames = {},
  isStorAssemblyAvailable = false,
}: PropsType) => {
  const { base, current, discounted } = prices.total;
  let { amount: currentAmount } = current.gross;
  let { amount: basePrice } = base.gross;
  const { amount: baseAssemblyPrice } = base.assembly;
  const { amount: currentAssemblyPrice } = current.assembly;

  let discountPrice = discounted ? discounted.gross.amount : currentAmount;

  if (shouldUseAssemblyPrice(prices, isStorAssemblyAvailable)) {
    currentAmount = currentAssemblyPrice;
    basePrice = baseAssemblyPrice;

    discountPrice = discounted ? discounted.assembly.amount : currentAssemblyPrice;
  }

  return (
    <div sx={classNames ? { ...styles.priceContainer, ...classNames } : styles.priceContainer}>
      {currentAmount &&
        (currentAmount !== basePrice || discountPrice !== currentAmount) &&
        (isProductLoading ? (
          <CartPriceSkeleton />
        ) : (
          <div sx={styles.discountedPrice}>{formatPrice(discountPrice) || formatPrice(currentAmount)}</div>
        ))}
      {isProductLoading ? (
        <CartPriceSkeleton />
      ) : (
        <div sx={styles.basePrice(currentAmount !== basePrice || discountPrice !== currentAmount)}>
          {formatPrice(basePrice)}
        </div>
      )}
    </div>
  );
};

export default observer(CartProductPrices);
